import { AnalyticsContext } from '@atlaskit/analytics-next';
import { SanitizedFormattedHtmlMessage } from '@atlassiansox/bxpkit-core';
import React from 'react';
import { messages } from '../../../../../messages/sign-up-form';
import { MigrationSourceDiv, WacSignupFormContainer } from './styled';

export type MigrationSourceProps = {
  readonly isClaimedMigration: boolean;
};

export function MigrationSource({ isClaimedMigration }: MigrationSourceProps) {
  return (
    <AnalyticsContext data={{ productKey: null }}>
      <WacSignupFormContainer>
        <MigrationSourceDiv>
          {isClaimedMigration && (
            <SanitizedFormattedHtmlMessage
              {...messages.claimedMigrationSource}
            />
          )}

          {!isClaimedMigration && (
            <SanitizedFormattedHtmlMessage
              {...messages.invalidMigrationSource}
            />
          )}
        </MigrationSourceDiv>
      </WacSignupFormContainer>
    </AnalyticsContext>
  );
}
